import React from 'react';

import { Form } from 'react-bootstrap';

const UITextDescription = ({ children }) => <Form.Text className="text-sm text-muted px-1">{children}</Form.Text>;

export default UITextDescription;
